import { List } from 'immutable';
import { createSelector } from 'reselect';
import { OperatorKey } from 'flow/types/EntityKeys';
import { State } from 'flow/types/State';

const selectOperators = (state: State) =>
    state.operator.get('operators', List());

export const selectOperatorData = (state: State) => state.operator.get('byKey');

export const selectOperatorName = (state: State, key: OperatorKey) =>
    state.operator.getIn(['byKey', key, 'name']);

export const selectSortedOperators = createSelector(
    [selectOperators],
    (operators) =>
        operators.sort((a, b) => (a.get('name') > b.get('name') ? 1 : -1)),
);

export const selectOperatorsSorted = createSelector(
    [selectOperatorData],
    (operators) => {
        return operators?.sort((a, b) =>
            a.get('name') > b.get('name') ? 1 : -1,
        );
    },
);
